// USA
export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    MENU: {
      NEW: 'new',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      DASHBOARD: 'Dashboard',
      SAMPLE: 'Sample',
      CHART: 'Chart',
      CONTENT_MANAGEMENT: 'Content management',
      EVENT: 'Event',
      INSTRUCTION: 'Instruction',
      MENU: 'Menu',
      SYSTEM_MANAGEMENT: 'System management',
      GROUP_USER: 'Group user',
      ORGANIZATION: 'Organization',
      ROLE: 'Role',
      USER: 'User',
      PERMISSION: 'Permission',
      REPORT: 'Report',
      REPORT_PERMISSION: 'Report permission',
      FOLDER_REPORT_PERMISSION: 'Folder report permission'
    },
    AUTH: {
      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: 'Don\'t have an account?',
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
      },
      LOGIN: {
        TITLE: 'Login Account',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.'
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.'
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'Username'
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      }
    },
    CONTENT_MANAGEMENT: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        INACTIVE: 'Inactive',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
        CANCEL: 'Cancel',
        CREATE: 'Create',
        EDIT: 'Edit',
        DELETE: 'Delete',
        SAVE: 'Save',
        VALIDATION_CHARACTER: ' character'
      },
      MENU: {
        MENU: 'Menu',
        MENU_LIST: 'Menu list',
        NEW_MENU: 'New Menu',
        SEARCH: {
          TITLE: 'Search by menu name',
          NAME: 'Search by name',
          DESCRIPTION: 'Search by description',
          STATUS: 'Filter by status'
        },
        DELETE_MENU_SIMPLE: {
          TITLE: 'Menu Delete',
          DESCRIPTION: 'Are you sure to permanently delete this menu?',
          WAIT_DESCRIPTION: 'Menu is deleting...',
          MESSAGE: 'Menu has been deleted'
        },
        DELETE_MENU_MULTY: {
          TITLE: 'Menu Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected menus?',
          WAIT_DESCRIPTION: 'Menus are deleting...',
          MESSAGE: 'Selected menus have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected menu',
          MESSAGE: 'Selected menu status have successfully been updated'
        },
        GRANT_PERMISSION: {
          ASSIGN_ROLE: 'Add roles',
          REMOVE_ROLE: 'Remove roles'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Menu has been updated',
          ADD_MESSAGE: 'Menu has been created'
        },
        FILTER_STATUS: {
          TITLE: 'Filter by status',
          ACTIVE: 'Active',
          INACTIVE: 'Inactive'
        },        
        PLACE_HOLDER: {
          TITLE: 'Insert menu name',
          ICON: 'Insert icon link',
          DESCRIPTION: 'Insert description'
        },
        MODEL: {
          ID: 'Id',
          TITLE: 'Menu',
          DESCRIPTION: 'Description',
          STATUS: 'Status',
          PAGE: 'Page',
          ICON: 'Icon',
          PARENT_ID: 'Parents menu',
          CREATED_DATE: 'Created date',
          ACTION: 'Action',
          APP: 'Application'
        },
        VALIDATION: {
          TITLE_REQUIRED: 'Title is required',
          TITLE_ALLOW: 'Title is allowed',
          TITLE_MINLENGTH: 'Title has min ',
          TITLE_MAXLENGTH: 'Title has max ',
          PAGE_REQUIRED: 'Page is required',
          PAGE_ALLOW: 'Page is allowed',
          DESCRIPTION_REQUIRED: 'Description is required',
          DESCRIPTION_ALLOW: 'Description is allowed',
          DESCRIPTION_MINLENGTH: 'Description has min ',
          DESCRIPTION_MAXLENGTH: 'Description has max ',
        }
      },
      MENU_PERMISSION: {
        SEARCH: {
          TITLE: 'Search by role name'
        }
      },
      INSTRUCTION: {
        INSTRUCTION: 'Instruction',
        INSTRUCTION_LIST: 'Instruction list',
        NEW_INSTRUCTION: 'New Instruction',
        SEARCH: {
          TITLE: 'Search by instruction name'
        },
        DELETE_INSTRUCTION_SIMPLE: {
          TITLE: 'Instruction Delete',
          DESCRIPTION: 'Are you sure to permanently delete this instruction?',
          WAIT_DESCRIPTION: 'Instruction is deleting...',
          MESSAGE: 'Instruction has been deleted'
        },
        DELETE_INSTRUCTION_MULTY: {
          TITLE: 'Instruction Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected instructions?',
          WAIT_DESCRIPTION: 'Instructions are deleting...',
          MESSAGE: 'Selected instructions have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected instruction',
          MESSAGE: 'Selected instruction status have successfully been updated'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Instruction has been updated',
          ADD_MESSAGE: 'Instruction has been created'
        },
        FILTER_STATUS: {
          TITLE: 'Filter by status',
          ACTIVE: 'Active',
          INACTIVE: 'Inactive'
        },
        MODEL: {
          NAME: 'Instruction name',
          DESCRIPTION: 'Description',
          FILE: 'Detail',
          STATUS: 'Status',
          ACTION: 'Action'
        },
        PLACE_HOLDER: {
          NAME: 'Insert instruction name',
          DESCRIPTION: 'Insert description',
          FILE: 'Upload file'
        }
      },
      EVENT: {
        EVENT: 'Event',
        EVENT_LIST: 'Event list',
        NEW_EVENT: 'New Event',
        SEARCH: {
          TITLE: 'Search by event name'
        },
        DELETE_EVENT_SIMPLE: {
          TITLE: 'Event Delete',
          DESCRIPTION: 'Are you sure to permanently delete this event?',
          WAIT_DESCRIPTION: 'Event is deleting...',
          MESSAGE: 'Event has been deleted'
        },
        DELETE_EVENT_MULTY: {
          TITLE: 'Event Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected events?',
          WAIT_DESCRIPTION: 'Events are deleting...',
          MESSAGE: 'Selected events have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected event',
          MESSAGE: 'Selected event status have successfully been updated'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Event has been updated',
          ADD_MESSAGE: 'Event has been created'
        }
      }
    },
    SYSTEM_MANAGEMENT: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        INACTIVE: 'Inactive',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
        CANCEL: 'Cancel',
        CREATE: 'Create',
        EDIT: 'Edit',
        DELETE: 'Delete',
        SAVE: 'Save',
        VALIDATION_CHARACTER: ' character'   
      },
      GROUP: {
        GROUP: 'Group user',
        GROUP_LIST: 'Group user list',
        NEW_GROUP: 'New group',          
        DELETE_GROUP_SIMPLE: {
          TITLE: 'Group Delete',
          DESCRIPTION: 'Are you sure to permanently delete this group?',
          WAIT_DESCRIPTION: 'Group is deleting...',
          MESSAGE: 'Group has been deleted'
        },
        DELETE_GROUP_MULTY: {
          TITLE: 'Group Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected groups?',
          WAIT_DESCRIPTION: 'Groups are deleting...',
          MESSAGE: 'Selected groups have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected group',
          MESSAGE: 'Selected group status have successfully been updated'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Group has been updated',
          ADD_MESSAGE: 'Group has been created'
        },
        FILTER_STATUS: {
          TITLE: 'Filter by status',
          ACTIVE: 'Active',
          INACTIVE: 'Inactive'
        }, 
        MODEL: {
          ID: 'Id',
          GROUP_NAME: 'Group name',
          DESCRIPTION: 'Description',
          STATUS: 'Status',
          USERS: 'Users',
          ACTION: 'Action'
        },
        VALIDATION: {
          NAME_REQUIRED: 'Group name is required',
          NAME_ALLOW: 'Group name is allowed',
          NAME_MINLENGTH: 'Group name has min ',
          NAME_MAXLENGTH: 'Group name has max ',
          DESCRIPTION_MINLENGTH: 'Description has min ',
          DESCRIPTION_MAXLENGTH: 'Description has max '
        }
      },
      ORGANIZATION: {
        ORGANIZATION: 'Organization',
        ORGANIZATION_LIST: 'Organization list',
        NEW_ORGANIZATION: 'New organization',          
        DELETE_ORGANIZATION_SIMPLE: {
          TITLE: 'Organization Delete',
          DESCRIPTION: 'Are you sure to permanently delete this organization?',
          WAIT_DESCRIPTION: 'Organization is deleting...',
          MESSAGE: 'Organization has been deleted'
        },
        DELETE_ORGANIZATION_MULTY: {
          TITLE: 'Organization Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected organizations?',
          WAIT_DESCRIPTION: 'Organizations are deleting...',
          MESSAGE: 'Selected Organizations have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected organization',
          MESSAGE: 'Selected organization status have successfully been updated'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Organization has been updated',
          ADD_MESSAGE: 'Organization has been created'
        },
        FILTER_STATUS: {
          TITLE: 'Filter by status',
          ACTIVE: 'Active',
          INACTIVE: 'Inactive'
        }, 
        MODEL: {
          ID: 'Id',
          NAME: 'Name',
          DESCRIPTION: 'Description',
          STATUS: 'Status',
          ADDRESS: 'Address',
          ACTION: 'Action'
        },
        VALIDATION: {
          NAME_REQUIRED: 'Name is required',
          NAME_ALLOW: 'Name is allowed',
          NAME_MINLENGTH: 'Name has min ',
          NAME_MAXLENGTH: 'Name has max ',
          DESCRIPTION_MINLENGTH: 'Description has min ',
          DESCRIPTION_MAXLENGTH: 'Description has max ',
          ADDRESS_MINLENGTH: 'Address has min ',
          ADDRESS_MAXLENGTH: 'Address has max '
        }
      },
      ROLE: {
        ROLE: 'Role',
        ROLE_LIST: 'Role list',
        NEW_ROLE: 'New role',    
        SEARCH: {
          TITLE: 'Search by role name'
        },      
        DELETE_ROLE_SIMPLE: {
          TITLE: 'Role Delete',
          DESCRIPTION: 'Are you sure to permanently delete this role?',
          WAIT_DESCRIPTION: 'Role is deleting...',
          MESSAGE: 'Role has been deleted'
        },
        DELETE_ROLE_MULTY: {
          TITLE: 'Role Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected roles?',
          WAIT_DESCRIPTION: 'Roles are deleting...',
          MESSAGE: 'Selected roles have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected role',
          MESSAGE: 'Selected role status have successfully been updated'
        },
        ASSIGN_USER: {
          TITLE: 'Assign user'
        },
        REMOVE_USER: {
          TITLE: 'Remove user'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Role has been updated',
          ADD_MESSAGE: 'Role has been created'
        },
        FILTER_STATUS: {
          TITLE: 'Filter by status',
          ACTIVE: 'Active',
          INACTIVE: 'Inactive'
        }, 
        MODEL: {
          ID: 'Id',
          NAME: 'Role',
          DESCRIPTION: 'Description',
          STATUS: 'Status',
          ACTION: 'Action'
        },
        VALIDATION: {
          NAME_REQUIRED: 'Role is required',
          NAME_ALLOW: 'Role is allowed',
          NAME_MINLENGTH: 'Role has min ',
          NAME_MAXLENGTH: 'Role has max ',
          DESCRIPTION_MINLENGTH: 'Description has min ',
          DESCRIPTION_MAXLENGTH: 'Description has max '
        }
      },
      USER: {
        USER: 'User',
        USER_LIST: 'User list',
        NEW_USER: 'New user',        
        SEARCH: {
          TITLE: 'Search by user name, full name'
        },  
        DELETE_USER_SIMPLE: {
          TITLE: 'User Delete',
          DESCRIPTION: 'Are you sure to permanently delete this user?',
          WAIT_DESCRIPTION: 'User is deleting...',
          MESSAGE: 'User has been deleted'
        },
        DELETE_USER_MULTY: {
          TITLE: 'User Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected users?',
          WAIT_DESCRIPTION: 'Users are deleting...',
          MESSAGE: 'Selected users have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected user',
          MESSAGE: 'Selected user status have successfully been updated'
        },
        EDIT: {
          UPDATE_MESSAGE: 'User has been updated',
          ADD_MESSAGE: 'User has been created'
        },
        FILTER_STATUS: {
          TITLE: 'Filter by status',
          ACTIVE: 'Unlock',
          INACTIVE: 'Lock'
        }, 
        MODEL: {
          ID: 'Id',
          USER_NAME: 'Username',
          FULLNAME: 'Full name',
          PHONE: 'Phone number',
          ROLENAME: 'Role name',
          ORGANIZATION: 'Organization',
          STATUS: 'Status',
          ACTION: 'Action',
          SEX: 'SEX'
        },
        PLACE_HOLDER: {
          NAME: 'Insert user name',
          PHONE: 'Insert phone number',
          ROLENAME: 'Select role',
          FULLNAME: 'Insert full name'          
        },
        VALIDATION: {
          USER_NAME_REQUIRED: 'Username is required',
          USER_NAME_ALLOW: 'Username is allowed',
          USER_NAME_MINLENGTH: 'Username has min ',
          USER_NAME_MAXLENGTH: 'Username has max ',
          ROLE_NAME_REQUIRED: 'Role is required',
          ROLE_NAME_ALLOW: 'Role is allowed',
        }
      },
      PERMISSION: {
        PERMISSION: 'Permission',
        PERMISSION_LIST: 'Permission list',
        SEARCH: {
          TITLE: 'Search by permission name'
        }
      }
    },  
    COMMON: {
      SELECTED_RECORDS_COUNT: 'Selected records count: ',
      ALL: 'All',
      INACTIVE: 'Inactive',
      ACTIVE: 'Active',
      FILTER: 'Filter',
      BY_STATUS: 'by status',
      BY_TYPE: 'by type',
      BY_ROLE: 'by role',
      BUSINESS: 'Business',
      INDIVIDUAL: 'Individual',
      SEARCH: 'Search',
      GRANT: 'Grant permission',
      IN_ALL_FIELDS: 'in all fields',
      CANCEL: 'Cancel',
      CREATE: 'Create',
      EXIT: 'Exit',
      CHOOSE_ROLE: 'Select role',
      CHOOSE_USER: 'Select user',
      EDIT: 'Edit',
      DELETE: 'Delete',
      SAVE: 'Save',
      GRANT_PERMISSION: 'Grant permission',
      ACCESS_PERMISSION: 'Access',
      UPLOAD: 'File attachment',
      SAVE_ORDER: 'Saving order',
      VALIDATION_CHARACTER: ' character',
      IMPORT: 'Import excel',
      EXPORT: 'Export excel'   
    },
    REPORT_MANAGEMENT: {
      REPORT: {
        REPORT: 'Report',
        REPORT_LIST: 'Report list',
        SEARCH: {
          TITLE: 'Search by report name'
        },
        NEW_REPORT: 'New report',
        DELETE_REPORT_SIMPLE: {
          TITLE: 'Delete report',
          DESCRIPTION: 'Are you sure to permanently delete this report?',
          WAIT_DESCRIPTION: 'Report is deleting...',
          MESSAGE: 'Report has been deleted'
        },
        BUTTON_TITLE: {
          EDIT: 'Edit report',
          DOWNLOAD: 'DownLoad report',
          DELETE: 'Delete report'
        },
        DELETE_REPORT_MULTY: {
          TITLE: 'Delete report',
          DESCRIPTION: 'Are you sure to permanently delete selected reports?',
          WAIT_DESCRIPTION: 'Reports are deleting...',
          MESSAGE: 'Selected reports have been deleted'
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected report',
          MESSAGE: 'Selected report status have successfully been updated'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Report has been updated',
          ADD_MESSAGE: 'Report has been created'
        },
        FILTER_STATUS: {
          TITLE: 'Filter by status',
          ACTIVE: 'Active',
          INACTIVE: 'Inactive'
        },
        MODEL: {
          ID: 'Id',
          CODE: 'Code',
          NAME: 'Name',
          DESCRIPTION: 'Description',
          STATUS: 'Status',
          FOLDER: 'Folder',
          ACTION: 'Actions',
          FILE: 'Detail'
        },
        PLACE_HOLDER: {
          CODE: 'Insert report code',
          NAME: 'Insert report name',
          FOLDER: 'Folder select',
          FILE: 'Upload report file'
        },
        VALIDATION: {
          CODE_REQUIRED: 'Code is allowed',
          CODE_ALLOW: 'Code is required',
          CODE_MINLENGTH: 'Code has min ',
          CODE_MAXLENGTH: 'Code has max ',
          NAME_REQUIRED: 'Name is required',
          NAME_ALLOW: 'Name is allowed',
          NAME_MINLENGTH: 'Name has min ',
          NAME_MAXLENGTH: 'Name has max ',
          DESCRIPTION_MINLENGTH: 'Description has min ',
          DESCRIPTION_MAXLENGTH: 'Description has max ',
          FOLDER_REQUIRED: 'Folder is required',
          FOLDER_ALLOW: 'Folder is allowed',
        }
      },
      REPORT_PERMISSION: {
        REPORT_PERMISSION: 'Report permission',
        REPORT_PERMISSION_LIST: 'Report permission list',    
        SEARCH: {
          TITLE: 'Search by role name, user name'
        },    
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected report',
          MESSAGE: 'Selected report status have successfully been updated'
        },
        DELETE_REPORT_PERMISSION_SIMPLE: {
          TITLE: 'Delete report permission',
          DESCRIPTION: 'Are you sure to permanently delete this report permission?',
          WAIT_DESCRIPTION: 'Report permission is deleting...',
          MESSAGE: 'Report permission has been deleted'
        },
        DELETE_REPORT_PERMISSION_MULTY: {
          TITLE: 'Delete report permission',
          DESCRIPTION: 'Are you sure to permanently delete selected report permissions?',
          WAIT_DESCRIPTION: 'Report permissions are deleting...',
          MESSAGE: 'Selected report permissions have been deleted'
        },
        ASSIGN: {
          ASSIGN_MESSAGE: 'Report has been granted permission'
        },
        FILTER_STATUS: {
          TITLE: 'Filter by status',
          ACTIVE: 'Active',
          INACTIVE: 'Inactive'
        },
        MODEL: {
          ID: 'Id',
          ROLE_NAME: 'Role',
          USER_NAME: 'User',
          REPORT_NAME: 'Report',
          READ: 'Read',
          SHARE: 'Share',
          STATUS: 'Status',
          ACTION: 'Actions'
        },
        VALIDATION: {
          ROLE_ALLOW: 'Selected role allowed',
          ROLE_REQUIRED: 'Selected role required'
        }
      },
      FOLDER_REPORT_PERMISSION: {
        FOLDER_REPORT_PERMISSION: 'Folder report permission',
        FOLDER_REPORT_PERMISSION_LIST: 'Folder report permission list',        
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected report',
          MESSAGE: 'Selected report status have successfully been updated'
        },
        ASSIGN: {
          ASSIGN_MESSAGE: 'Folder report has been granted permission'
        },
        FILTER_STATUS: {
          TITLE: 'Filter by status',
          ACTIVE: 'Active',
          INACTIVE: 'Inactive'
        },
        DELETE_REPORT_PERMISSION_SIMPLE: {
          TITLE: 'Delete folder report permission',
          DESCRIPTION: 'Are you sure to permanently delete this folder report permission?',
          WAIT_DESCRIPTION: 'Folder report permission is deleting...',
          MESSAGE: 'Folder report permission has been deleted'
        },
        DELETE_REPORT_PERMISSION_MULTY: {
          TITLE: 'Delete folder report permission',
          DESCRIPTION: 'Are you sure to permanently delete selected folder report permissions?',
          WAIT_DESCRIPTION: 'Folder report permissions are deleting...',
          MESSAGE: 'Selected folder report permissions have been deleted'
        },
        MODEL: {
          ID: 'Id',
          ROLE_NAME: 'Role',
          USER_NAME: 'User',
          FOLDER_NAME: 'Folder',
          STATUS: 'Status',
          ACTION: 'Actions',
          WRITE: 'Add report',
          UPDATE: 'Edit report'
        },
        VALIDATION: {

        }
      },
      FOLDER_REPORT: {
        SEARCH: {
          TITLE: 'Search by folder name'
        }
      }
    }
  }
};
